import React from "react";
import Tooltip from "rc-tooltip";
import SkillContent from "./SkillContent";

import { domainInfo } from "../../util/domainInfo";

import "./index.scss";
import "./rc_tooltip_override.scss";

export default function TooltipHandler(props) {
  const { data, isDragging = false } = props;

  let trigger = "hover";
  if (isDragging) trigger = "click";

  return (
    <Tooltip
      placement="left"
      // animation="zoom"
      // onVisibleChange={() => setVisible(!visible)}
      trigger={trigger}
      // mouseLeaveDelay={0}
      mouseLeaveDelay={0.01}
      destroyTooltipOnHide={true}
      overlay={() => <Overlay data={data} />}
    >
      {props.children}
    </Tooltip>
  );
}

function Overlay(props) {
  const { data } = props;

  const { skillName, skillArea } = data;

  const abbreviation = domainInfo[data.domain].abbr;

  return (
    <div className="info-card">
      <div className="info-card-header">
        <div className="title-wrapper">
          <div className="abbreviation">{abbreviation}</div>
          <div className="title">{skillName}</div>
        </div>
        <div className="subtitle">{skillArea}</div>
      </div>
      <SkillContent data={data} />
      {/* <div></div> */}
      {/* <div className="info-button hover-opacity">More Information</div> */}
    </div>
  );
}
